import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useQuestions } from "./hooks/useQuestions";
import { Select } from "../../../../../shared/Select/Select";
import { Input } from "../../../../../shared/Input/Input";
import { Button } from "../../../../../shared/Button/Button";
import { not } from "../../../../../utilities/fp";
import { PasswordVisibilityToggle } from "./shared/PasswordVisibilityToggle";
import { Date } from "./shared/Date";
import { ModalConfirm } from "./boxes/ModalConfirm";
import { useSubmit } from "./hooks/useSubmit";
import { Note } from "./shared/Note";

export const SecurityQuestion = ({
  questionId,
  answerChangedAt,
  refetchProfile,
}) => {
  const questions = useQuestions();
  const submit = useSubmit();

  const [isAnswerVisible, setIsAnswerVisible] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [answer, setAnswer] = useState("");
  const [questionOption, setQuestionOption] = useState(null);

  const onPreSubmit = () => {
    if (questionOption && answer) {
      setIsPasswordModalOpen(true);
    }
  };

  const onSubmit = (password) => {
    submit
      .initiate({
        questionId: questionOption.value,
        answer,
        password,
      })
      .then(() => {
        setIsPasswordModalOpen(false);
        setAnswer("");
        refetchProfile();
      });
  };

  useEffect(() => {
    if (questionId && !questionOption && !questions.isLoading) {
      setQuestionOption(questions.getOptionById(questionId));
    }
  }, [questionId, questionOption, questions.isLoading]);

  return (
    <div>
      <div className={styles.header}>
        Security Question is Required for 2FA <span>*</span>
      </div>
      <div className={styles.container}>
        <h5 className={styles.title}>Your Security Question can be used to verify your identity in the event you cannot receive an SMS OTP code.</h5>
        <div className={styles.wrapper}>
          <div>
            <Select
              size="small"
              options={questions.options}
              isLoading={questions.isLoading}
              placeholder="Choose a question"
              value={questionOption}
              onChange={setQuestionOption}
            />
            <Date>{answerChangedAt}</Date>
          </div>
          <div>
            <Input
              size="small"
              type={isAnswerVisible ? "text" : "password"}
              placeholder={answerChangedAt ? "*****************" : "Write answer"}
              className={styles.answer}
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              rightAdornment={
                <PasswordVisibilityToggle
                  isVisible={isAnswerVisible}
                  onToggle={() => setIsAnswerVisible(not)}
                />
              }
            />
            <Note>Please note: Your answer is case sensitive</Note>
          </div>
        </div>
        <Button
          size="small"
          isDisabled={!questionOption || !answer?.trim() || submit.isLoading}
          onClick={onPreSubmit}
        >
          Update answer
        </Button>
        {isPasswordModalOpen && (
          <ModalConfirm
            onClose={() => setIsPasswordModalOpen(false)}
            onSubmit={onSubmit}
            isSubmitting={submit.isLoading}
          />
        )}
      </div>
    </div>
  );
};
